const navbarMenu = document.getElementById("menu");
const burgerMenu = document.getElementById("burger");
const headerMenu = document.getElementById("header");

// Open Close Navbar Menu on Click Burger
burgerMenu?.addEventListener("click", () => {
    burgerMenu?.classList.toggle("is-active");
    navbarMenu?.classList.toggle("is-active");
});


// Close Navbar Menu on Click Menu Links
document.querySelectorAll(".menu-link").forEach((link) => {
    link?.addEventListener("click", () => {
        burgerMenu?.classList.remove("is-active");
        navbarMenu?.classList.remove("is-active");
    });
});

// Change Header Background on Scrolling
window.addEventListener("scroll", () => {
    if (this.scrollY >= 85) {
        headerMenu?.classList.add("on-scroll");
    } else {
        headerMenu?.classList.remove("on-scroll");
    }
});

// Fixed Navbar Menu on Window Resize
window.addEventListener("resize", () => {
    if (window.innerWidth > 768) {
        if (navbarMenu?.classList.contains("is-active")) {
            navbarMenu.classList.remove("is-active");
        }
    }
});
